import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=93a9d128&scoped=true"
import script from "./Billboard.vue?vue&type=script&lang=js"
export * from "./Billboard.vue?vue&type=script&lang=js"
import style0 from "./Billboard.vue?vue&type=style&index=0&id=93a9d128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a9d128",
  null
  
)

export default component.exports